import React, { useEffect,useCallback } from 'react';
import List from '@mui/material/List';
import {
    Box,
    InputAdornment,
    TextField,
    Typography,
} from '@mui/material';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import Checkbox from '@mui/material/Checkbox';
import Chip from '@mui/material/Chip';
import { Downgraded, useState } from '@hookstate/core';
import SearchIcon from '@mui/icons-material/Search';

const listStyle = {
    width: '100%',
    height: '50vh',
    overflowY: 'auto',
    '&::-webkit-scrollbar': {
        width: '5px',
        height: '5px',
        backgroundColor: '#f1f1f1',
    },
    '&::-webkit-scrollbar-thumb': {
        background: '#c1c1c1',
    }
}
const ParticipantUserAddedCheckList = (props) => {
    const [selected, setselected] = React.useState([]);;
    const [addsearch, setAddSearch] = React.useState('');
    const [allCheck, setAllCheck] = React.useState(false);

    const handleToggle = useCallback((value) => {
        const newSelected = [...selected];
        const currentIndex = newSelected.indexOf(value.userID);
        if (currentIndex === -1) {
            newSelected.push(value.userID);
        } else {
            newSelected.splice(currentIndex, 1);
        }

        if (newSelected.length > 0) {
            props.checkUsers(newSelected);
        }
        setselected(newSelected);
    },[props.selectedUsers,selected])

    useEffect(() => {
        if (props.selectedUsers && !allCheck) {
            if (allCheck === false){
                setselected([...props.selectedUsers]);
            }
        }
        if(props.resetCheckBox){
            setselected([])
            setAllCheck(false)
            props.checkUsers([]);
        }
   },  [props.selectedUsers]);

   

    const setSearchValue = (value) => {
        setAddSearch(value);
        props.setAddSearch(value);

        if (value.trim().length > 0) {
            const newUserData = props.data.filter(
                (x) =>
                    x.name.toLowerCase().includes(value.toLowerCase()) ||
                    (x.userTags !== null && x.userTags.toLowerCase().includes(value.toLowerCase()))
            );
            props.setInviteParticipants(newUserData);
        }
    }

    const handleAllCheck = () => {
        const data = props.data.map((item) => item.userID);

        if (allCheck === false)
        {
            setAllCheck(true)
            setselected(data)
            props.checkUsers(data)
        } else
        {
            setAllCheck(false)
            setselected([])
            props.checkUsers([])
        }
    };
    // console.log("selected",selected,"allCheck",allCheck);
    return (
        <>
            <Box sx={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'left',
                alignItems: 'left',
                padding:'3px'
            }}>
                <Checkbox
                    edge="start"
                    checked={allCheck}
                    onChange={handleAllCheck}
                    disableRipple
                    sx={{ '& .MuiSvgIcon-root': { fontSize: 20 } }}
                />
                <TextField
                    size="small"
                    fullWidth={true}
                    placeholder="Search Individuals or Groups"
                    InputProps={{
                        style: {
                            padding: 0
                          },
                        startAdornment: (
                            <InputAdornment position="start">
                                <SearchIcon />
                            </InputAdornment>
                        ),
                    }}
                    sx={{padding:0}}
                    value={props.addsearch === "" ? props.addsearch : addsearch}
                    onChange={(event) => setSearchValue(event.target.value)}
                />
            </Box>
            <List sx={listStyle}>
                {props.data &&
                    props.data.map((item, index) => {
                        const labelId = `checkbox-list-label-${index}`;
                        // console.log('selected : ', selected.get());
                        // console.log('check : ', selected.get().indexOf(item.userID));
                        return (
                            <ListItem key={`user_${index}`} disablePadding disabled={props.disabledBox ? true : false}>
                                <ListItemButton
                                    sx={{ padding: '3px' }}
                                    role={undefined}
                                    onClick={() => !props.disabledBox ? handleToggle(item) : null}
                                    dense>
                                    {props.sentInvitationList != undefined ? null :
                                        <ListItemIcon sx={{ height: '28px', minWidth: '28px' }}>
                                            <Checkbox
                                                edge="start"
                                                checked={
                                                    selected.includes(item.userID)
                                                }
                                                tabIndex={-1}
                                                disableRipple
                                                inputProps={{
                                                    'aria-labelledby': labelId,
                                                }}
                                                sx={{ '& .MuiSvgIcon-root': { fontSize: 20 } }}
                                            />
                                        </ListItemIcon>
                                    }
                                    <ListItemText sx={props.showRole ? { textAlign: 'left', flex: '0.3' } : { textAlign: 'left', flex: '1' }}

                                        primary={
                                            <>
                                                <Typography variant='span' sx={{ alignItems: 'center', display: 'flex', fontSize: '15px' }}>
                                                    {item.name.toLowerCase()}&nbsp;
                                                </Typography>
                                                <Typography sx={{ fontSize: 0 }}><a href={`javascript: void(0)`} style={{ textDecoration: 'none', fontSize: '12px' }}>
                                                    {item.email}</a></Typography> 
                                                {item.userType && item.userType == "Admin" ? <Typography
                                                    fontSize={11}
                                                    sx={{ color: 'red' }}
                                                >
                                                    Admin
                                                </Typography> : null}
                                                </>

                                        }
                                        secondary={props.showRole && props.showRole ?
                                            <a
                                                href={`javascript: void(0)`} style={{ textDecoration: 'none', fontSize: '12px', wordBreak: 'break-word' }}>
                                                {item.email}
                                            </a> : null
                                        }
                                    />
                                    {props.showRole && <ListItemText sx={{ textAlign: 'left', flex: '0.3' }}

                                        primary={item.roleName}
                                    />}
                                    {props.showRole && <ListItemText sx={{ textAlign: 'left', flex: '0.3' }}
                                    >
                                        {item.userTags !== null && item.userTags.split(', ').map((tag, i) => {
                                            return <Chip key={i} sx={{ mr: '4px', mb: '2px' }} label={tag} />
                                        })}
                                    </ListItemText>}
                                </ListItemButton>
                            </ListItem>
                        );
                    })}
            </List></>

    );
};

export default React.memo(ParticipantUserAddedCheckList);
